export class APIFinder<T = unknown> {

  constructor(private apiName: string,
              private tryCount: number = 7) {
  }

  public find(window: any): null | T {

    let api = this.findAPIInWindow(window.parent); // we start at parent
    if (api == null) {
      api = this.findInOpenerHierarchy(window);
    }

    return api;
  }

  private findInOpenerHierarchy(window: any) {

    let tries = 0;
    let api: any = null;
    let opener = window.opener;
    while (api == null && (opener && tries < this.tryCount)) {

      api = this.findAPIInWindow(opener);

      tries++;
      opener = opener.opener;
    }

    return api;
  }

  private findAPIInWindow(win: any) {
    let tries = 0;
    let api: any = null;
    while (api == null && (win && tries < this.tryCount)) {

      try {
        api = win[this.apiName] || null;
      } catch (err) {
        api = null;
      }

      tries++;
      win = win.parent;
    }

    return api;
  }
}
